// plugins/vuetify.js
import { createVuetify } from "vuetify";
import "vuetify/styles"; // Global CSS
import { aliases, mdi } from "vuetify/iconsets/mdi";

export default createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#763493",
          secondary: "#D8ADEB",
          accent: "#FBE4FF",
          background: "#F9F5F4",
        },
      },
    },
  },
  defaults: {
    global: {
      style: {
        fontFamily: "Montserrat, sans-serif",
      },
    },
  },
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      smmd: 800,
      md: 960,
      lg: 1264,
      xl: 1904,
    },
  },
});
